var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 3C2.5 2.44772 2.94772 2 3.5 2H20.5C21.0523 2 21.5 2.44772 21.5 3V4.18975C21.5 6.26721 20.5772 9.23734 18.9813 10.5673L17.2991 11.9691C16.1591 12.9191 15.5 14.3264 15.5 15.8102V19.0862C15.5 19.4814 15.2673 19.8395 14.9061 20L10.4061 22C10.0968 22.1375 9.73892 22.1091 9.45509 21.9247C9.17125 21.7402 9 21.4247 9 21.0862V15.9544C9 14.4021 8.27898 12.9378 7.04855 11.9913L5.23203 10.594C3.50943 9.26889 2.5 6.21887 2.5 4.04559V3ZM4.5 4V4.04559C4.5 5.59794 5.22102 8.06223 6.45145 9.00871L8.26798 10.406C9.99057 11.7311 11 13.7811 11 15.9544V19.5474L13.5 18.4363V15.8102C13.5 13.7328 14.4228 11.7627 16.0187 10.4327L17.7009 9.03086C18.8409 8.08089 19.5 5.67365 19.5 4.18975V4H4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4c6a0d68.svg";
export { ForwardRef as ReactComponent };